import { render, staticRenderFns } from "./UnsubscribeComponent.vue?vue&type=template&id=2bae0fa4&scoped=true"
import script from "./UnsubscribeComponent.vue?vue&type=script&lang=js"
export * from "./UnsubscribeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae0fa4",
  null
  
)

export default component.exports